import Vue from 'vue'
import VueRouter from 'vue-router'
import { getMenus } from '@/api/menus'
import Store from '@/store'
import { convertToTree } from '@/utils'
import cookie from 'js-cookie'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/login',
            name: 'login',
            component: () => import(/* webpackChunkName: "login" */ '../views/login/LoginView')
        },
        {
            path: '/',
            component: () => import(/* webpackChunkName: "login" */ '../views/main/MainView'),
            children: [{
                path: '',
                name: 'home',
                meta: {
                    title: '首页'
                },
                component: () => import(/* webpackChunkName: "home" */ '../views/home/HomeView.vue')
            },
            {
                path: 'saleLogs',
                name: 'saleLogs',
                meta: {
                    title: 'saleLogs'
                },
                component: () => import(/* webpackChunkName: "saleLogs" */ '../views/financial/SaleLogsView.vue')
            },
            {
                path: 'procureLogs',
                name: 'procureLogs',
                meta: {
                    title: 'procureLogs'
                },
                component: () => import(/* webpackChunkName: "procureLogs" */ '../views/financial/ProcureLogsView.vue')
            },
            {
                path: 'materialProcureLogs',
                name: 'materialProcureLogs',
                meta: {
                    title: 'materialProcureLogs'
                },
                component: () => import(/* webpackChunkName: "materialProcureLogs" */ '../views/financial/materialProcureLogsView.vue')
            },
            {
                path: 'norm',
                name: 'norm',
                meta: {
                    title: '产品规格'
                },
                component: () => import(/* webpackChunkName: "specifications" */ '../views/product/SpecificationsView.vue')
            },
            {
                path: 'materialNorm',
                name: 'materialNorm',
                meta: {
                    title: '物料规格'
                },
                component: () => import(/* webpackChunkName: "MaterialNorm" */ '../views/material/MaterialNormView.vue')
            },
            {
                path: 'materialNormLogs',
                name: 'materialNormLogs',
                meta: {
                    title: '物料库存'
                },
                component: () => import(/* webpackChunkName: "materialNormLogs" */ '../views/material/MaterialNormLogsView.vue')
            },
            {
                path: 'DataReport',
                name: 'DataReport',
                meta: {
                    title: '采购单'
                },
                component: () => import(/* webpackChunkName: "DataReport" */ '../views/financial/DataReportView.vue')
            },
            {
                path: 'AddProcureOrder',
                name: 'AddProcureOrder',
                meta: {
                    title: '添加采购单'
                },
                component: () => import(/* webpackChunkName: "AddProcureOrder" */ '../views/procure/AddProcureOrderView.vue')
            },
            {
                path: 'AddMaterialProcureOrder',
                name: 'AddMaterialProcureOrder',
                meta: {
                    title: '添加物料采购单'
                },
                component: () => import(/* webpackChunkName: "AddMaterialProcureOrder" */ '../views/material/procure/AddProcureOrderView.vue')
            },
            {
                path: 'SpecLog',
                name: 'SpecLog',
                meta: {
                    title: '入库记录'
                },
                component: () => import(/* webpackChunkName: "SpecLog" */ '../views/product/SpecLogView.vue')
            }, {
                path: 'AddSaleOrder',
                name: 'AddSaleOrder',
                meta: {
                    title: '添加销售单'
                },
                component: () => import(/* webpackChunkName: "AddSaleOrder" */ '../views/sale/AddSaleOrderView.vue')
            }, {
                path: 'EditSaleOrder',
                name: 'EditSaleOrder',
                meta: {
                    title: '编辑销售单'
                },
                component: () => import(/* webpackChunkName: "EditSaleOrder" */ '../views/sale/EditSaleOrderView.vue')
            },
            {
                path: 'EditMaterialBuyOrder',
                name: 'EditMaterialBuyOrder',
                meta: {
                    title: '物料编辑采购单'
                },
                component: () => import(/* webpackChunkName: "EditMaterialBuyOrder" */ '../views/material/procure/EditBuyOrderView.vue')
            },
            {
                path: 'AddMaterialAssociation',
                name: 'AddMaterialAssociation',
                meta: {
                    title: '添加物料关联'
                },
                component: () => import(/* webpackChunkName: "AddMaterialAssociation" */ '../views/material/productAssociation/materialSelectView.vue')
            },
            {
                path: 'AddMaterialCombination',
                name: 'AddMaterialCombination',
                meta: {
                    title: '添加物料组合'
                },
                component: () => import(/* webpackChunkName: "AddMaterialCombination" */ '../views/material/materialCombination/AddMaterialCombinationView.vue')
            },
            {
                path: 'EditMaterialCombination',
                name: 'EditMaterialCombination',
                meta: {
                    title: '编辑物料组合'
                },
                component: () => import(/* webpackChunkName: "EditMaterialCombination" */ '../views/material/materialCombination/EditMaterialCombinationView.vue')
            },
            {
                path: 'EditBuyOrder',
                name: 'EditBuyOrder',
                meta: {
                    title: '编辑采购单'
                },
                component: () => import(/* webpackChunkName: "EditBuyOrder" */ '../views/procure/EditBuyOrderView.vue')
            }, {
                path: 'AddExpensesGroup',
                name: 'AddExpensesGroup',
                meta: {
                    title: '添加费用支出分组'
                },
                component: () => import(/* webpackChunkName: "AddExpensesGroup" */ '../views/procure/AddExpensesGroupView.vue')
            }, {
                path: 'AddMaterialExpensesGroup',
                name: 'AddMaterialExpensesGroup',
                meta: {
                    title: '添加费用支出分组'
                },
                component: () => import(/* webpackChunkName: "AddMaterialExpensesGroup" */ '../views/material/AddMaterialExpensesGroupView.vue')
            },
            {
                path: 'AddIncomeGroup',
                name: 'AddIncomeGroup',
                meta: {
                    title: '添加费用收入分组'
                },
                component: () => import(/* webpackChunkName: "AddIncomeGroup" */ '../views/sale/AddIncomeGroupView.vue')
            }]
        },
        {
            path: '*',
            component: () => import(/* webpackChunkName: "404" */ '../views/404/NotFound.vue')
        }
    ]
})

let dynamicRoutesAdded = false // 用于跟踪是否已添加动态路由的标志
// 路由导航守卫
router.beforeEach(async(to, from, next) => {
    if (to.name !== 'login' && !cookie.get('id')) {
        next({ name: 'login' })
    } else {
        if (!dynamicRoutesAdded) {
            try {
                if (!cookie.get('id')) {
                    return next()
                }
                // 获取菜单数据
                const data = await getMenus({ ids: cookie.get('rules'), id: cookie.get('id') })
                addDynamicRoutes(data[0]) // 添加动态路由
                Store.dispatch('setMenus', convertToTree(data[0])) // 将菜单数据转为树形结构并存储到 Vuex 中
                Store.dispatch('setSeeAll', data[1][0].seeall)
                dynamicRoutesAdded = true // 设置标志为 true，表示动态路由已添加
                next(to.path) // 继续路由导航到目标路径
            } catch (error) {
                next() // 如果加载失败，继续路由导航
            }
        } else {
            next() // 如果动态路由已添加，继续路由导航
        }
    }
})

// 添加动态路由
function addDynamicRoutes(params) {
    const parentRoute = router.options.routes.find(r => r.path === '/') // 找到根路由
    if (!parentRoute.children) {
        parentRoute.children = [] // 如果子路由数组不存在，则初始化为空数组
    }

    params.forEach(item => {
        // 检查是否已存在相同名称的路由
        if (!parentRoute.children.some(route => route.name === item.name)) {
            const route = {
                path: `/${item.path}`, // 添加斜杠，确保路由路径正确
                name: item.name,
                meta: {
                    title: item.title
                },
                component: () => import(/* webpackChunkName: "[request]" */ `../views/${item.parent_path}/${item.path}View.vue`)
            }
            parentRoute.children.push(route) // 将动态路由添加为子路由
        }
    })
    // 更新路由的 matcher，确保动态路由生效
    router.matcher = new VueRouter({ mode: 'history', routes: router.options.routes }).matcher
}

export function resetRouter() {
    // 重置路由器为其初始状态
    dynamicRoutesAdded = false
    router.matcher = new VueRouter({ mode: 'history', routes: router.options.routes })
}

export default router
